<template>
  <main class="company-home">
    <section id="col" class="home-hero" aria-labelledby="home-title">
      <div class="home-container">
        <div class="hero-content">
          <p class="hero-eyebrow">软件定制开发 · 网站与应用建设 · 系统集成与技术服务</p>
          <h1 id="home-title"><span>软件，让业务</span><span class="hero-accent">更简单。</span></h1>
          <p class="hero-description">提供软件定制开发、网站建设、APP 与小程序开发。<br />从业务系统建设到平台集成，服务不同场景的开发需求。</p>
          <div class="hero-actions">
            <a-button type="primary" size="large" @click="openConsult">咨询合作</a-button>
            <a :href="sectionHref('services')" class="hero-more" @click.prevent="scrollTo('services')">了解服务<a-icon type="right" /></a>
          </div>
        </div>
      </div>
    </section>

    <section id="services" class="home-section" aria-labelledby="services-title">
      <div class="home-container">
        <div class="section-heading">
          <h2 id="services-title">从业务需求，到软件应用。</h2>
          <p>覆盖系统设计、功能开发、平台集成与应用支持。</p>
        </div>
        <div class="service-list">
          <article v-for="service in services" :key="service.title" class="service-item">
            <a-icon :type="service.icon" class="service-icon" />
            <h3>{{ service.title }}</h3>
            <p>{{ service.description }}</p>
          </article>
        </div>
      </div>
    </section>

    <div class="home-section company-details">
      <div class="home-container company-details-grid">
        <section id="solutions" class="solutions-section" aria-labelledby="solutions-title">
          <div class="section-heading">
            <h2 id="solutions-title">理解行业，贴近实际。</h2>
            <p>聚焦项目协作与保函办理中的实际问题。</p>
          </div>
          <div class="solution-list">
            <article v-for="solution in solutions" :key="solution.title" class="solution-item">
              <div class="solution-heading">
                <a-icon :type="solution.icon" class="solution-icon" />
                <h3>{{ solution.title }}</h3>
              </div>
              <p>{{ solution.description }}</p>
              <div class="solution-flow" aria-label="应用场景">
                <span v-for="(step, index) in solution.steps" :key="step"><a-icon v-if="index" type="right" />{{ step }}</span>
              </div>
            </article>
          </div>
        </section>

        <section id="about" class="about-section" aria-labelledby="about-title">
          <div class="section-heading"><h2 id="about-title">关于我们</h2><p>以技术连接业务，让软件融入日常。</p></div>
          <div class="about-copy">
            <p>台州金电保数字科技有限公司是一家提供软件开发与技术服务的科技企业，面向企业、机构及创业团队，开展软件定制开发、网站建设、APP 与小程序开发、业务管理系统及各类平台建设，帮助客户将业务需求转化为实际可用的软件产品。</p>
            <p>我们的服务覆盖需求分析、产品设计、系统开发、接口对接、上线部署及后续维护。无论是新项目建设、现有系统升级，还是功能扩展与多平台集成，我们都从实际使用场景出发，梳理业务流程，明确功能范围，兼顾系统的易用性、稳定性和后续扩展需求。</p>
            <p>在行业应用方面，我们围绕企业经营管理、项目协作、信息服务等场景开展系统建设，并在招投标、保函等领域积累开发与平台对接经验。我们也面向更多行业提供开发服务，根据不同项目的业务特点，制定相应的技术方案与实施安排。</p>
            <p>我们重视沟通与交付，关注软件能否解决实际问题。从前期需求梳理到交付后的应用支持，持续与客户沟通，让系统贴合日常工作，也能随着业务发展不断完善。</p>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Index',
  data() {
    return {
      services: [
        { icon: 'code', title: '软件定制开发', description: '将业务规则转化为清晰的功能设计，完成开发与交付，服务企业日常管理。' },
        { icon: 'api', title: '系统集成对接', description: '打通已有平台与数据接口，减少重复录入，衔接不同系统的业务环节。' },
        { icon: 'tool', title: '行业技术指导', description: '提供建设方案、业务流程与系统应用指导，协助团队落实技术要求。' },
      ],
      solutions: [
        { icon: 'project', title: '招投标行业软件', description: '围绕项目信息、资料流转、进度跟踪与协作记录，支持招投标相关业务的有序开展。', steps: ['项目资料', '流程跟踪', '协作记录'] },
        { icon: 'safety-certificate', title: '保函系统与技术指导', description: '衔接申请、审核、出函与查验等环节，结合机构要求梳理办理流程，并提供保函业务技术指导。', steps: ['申请审核', '出函查验', '业务指导'] },
      ],
    };
  },
  methods: {
    openConsult() {
      this.$router.push({ path: '/index', query: { ...this.$route.query, online_consult: '1' } });
    },
    sectionHref(id) {
      return `#/index?anch=${encodeURIComponent(`#${id}`)}`;
    },
    scrollTo(id) {
      if (this.$route.query.anch !== `#${id}`) {
        this.$router.push({ path: '/index', query: { ...this.$route.query, anch: `#${id}` } });
        return;
      }
      const target = document.getElementById(id);
      if (target) target.scrollIntoView({ block: 'start' });
    },
  },
};
</script>

<style lang="less" scoped>
.company-home {
  background: #fff;
  color: #6e6e73;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;

  h1, h2, h3 { margin: 0; color: #1d1d1f; font-weight: 600; }
  h2 { font-size: 36px; line-height: 1.4; letter-spacing: -.8px; text-wrap: balance; }
  h3 { font-size: 22px; line-height: 1.5; letter-spacing: -.3px; }
  p { font-size: 16px; line-height: 1.85; }
  section { scroll-margin-top: 84px; }
  .ant-btn-lg { height: 44px; padding: 0 25px; border-radius: 24px; font-size: 15px; }
  a:focus-visible, button:focus-visible { outline: 2px solid #0071e3 !important; outline-offset: 5px; }
}
.home-container { width: ~"calc(100% - 80px)"; max-width: 1120px; margin: 0 auto; }
.home-section { padding: 80px 0; }
.home-hero { padding: 88px 0; background: linear-gradient(180deg, #fff 45%, #f5f5f7 100%); }
.hero-content { text-align: center; }
// Paragraph margins override the legacy global !important reset locally.
.hero-eyebrow { margin: 0 0 18px !important; color: #0066cc; font-size: 14px !important; font-weight: 500; letter-spacing: 2px; }
.company-home h1 { font-size: clamp(42px, 5vw, 68px); line-height: 1.25; letter-spacing: -2px; }
.company-home h1 > span { display: inline-block; white-space: nowrap; }
.company-home h1 > .hero-accent { color: #0071e3; }
.hero-description { margin: 22px auto 0 !important; font-size: 18px !important; line-height: 1.8 !important; }
.hero-actions { display: flex; align-items: center; justify-content: center; gap: 28px; margin: 26px 0 0; }
.hero-actions .ant-btn-primary { background: #0071e3; border-color: #0071e3; box-shadow: none; text-shadow: none; transition: background .2s, transform .2s; }
.hero-actions .ant-btn-primary:hover, .hero-actions .ant-btn-primary:focus { background: #0077ed; border-color: #0077ed; }
.hero-actions .ant-btn-primary:active { transform: scale(.98); }
.hero-more { display: inline-flex; align-items: center; gap: 6px; padding: 10px 0; color: #0066cc; font-size: 15px; }
.hero-more .anticon { font-size: 11px; transition: transform .2s; }
.hero-more:hover { color: #0071e3; .anticon { transform: translateX(3px); } }
.section-heading { margin-bottom: 40px; text-align: left; }
.section-heading > p { margin: 14px 0 0 !important; }
.service-list { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 52px; }
.service-item { padding: 4px 0; }
.service-icon { display: block; margin-bottom: 20px; color: #0071e3; font-size: 30px; text-align: left; }
.service-item p { margin: 12px 0 0 !important; font-size: 15px; }
.company-details { background: #f5f5f7; }
.company-details-grid { display: grid; grid-template-columns: minmax(0, .9fr) minmax(0, 1.1fr); align-items: start; gap: 64px; }
.solutions-section, .about-section { min-width: 0; }
.company-details h2 { font-size: 32px; }
.company-details .section-heading { margin-bottom: 32px; }
.company-details .section-heading > p { font-size: 15px; }
.solution-list { display: grid; grid-template-columns: 1fr; gap: 20px; }
.solution-item { padding: 28px; border: 1px solid rgba(0, 0, 0, .04); border-radius: 16px; background: #fff; }
.solution-heading { display: flex; align-items: center; gap: 14px; }
.solution-heading h3 { min-width: 0; text-wrap: balance; }
.solution-icon { flex-shrink: 0; color: #0071e3; font-size: 26px; }
.solution-item p { margin: 14px 0 0 !important; font-size: 15px; }
.solution-flow { display: flex; flex-wrap: wrap; gap: 8px 14px; margin-top: 20px; color: #515154; font-size: 12px; }
.solution-flow span { display: inline-flex; align-items: center; gap: 14px; }
.solution-flow .anticon { color: #a1a1a6; font-size: 9px; }
.about-copy p { margin: 0 !important; color: #515154; font-size: 16px; line-height: 1.95; text-wrap: pretty; }
.about-copy p + p { margin-top: 20px !important; }
@media (max-width: 1024px) {
  .company-details-grid { grid-template-columns: 1fr; gap: 56px; }
  .solution-list { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .about-copy { max-width: 860px; }
}
@media (max-width: 900px) {
  .home-section { padding: 72px 0; }
  .home-hero { padding: 72px 0; }
  .company-home h2 { font-size: 32px; }
  .service-list { gap: 32px; }
}
@media (max-width: 760px) {
  .solution-list { grid-template-columns: 1fr; }
}
@media (max-width: 600px) {
  .home-container { width: ~"calc(100% - 40px)"; }
  .home-section > .home-container { padding-right: 28px; }
  .home-section { padding: 56px 0; }
  .home-hero { padding: 56px 0; }
  .hero-eyebrow { margin-bottom: 16px !important; font-size: 12px !important; letter-spacing: 1px; }
  .company-home h1 { font-size: clamp(34px, 9vw, 48px); letter-spacing: -1px; }
  .company-home h1 > span { display: block; }
  .company-home h2 { font-size: clamp(22px, 7.2vw, 27px); letter-spacing: -.6px; }
  .company-home h3 { font-size: 21px; }
  .hero-description { margin-top: 20px !important; font-size: 14px !important; }
  .hero-actions { gap: 24px; margin: 24px 0 0; }
  .section-heading, .company-details .section-heading { margin-bottom: 30px; }
  .section-heading > p, .company-details .section-heading > p { margin-top: 12px !important; font-size: 14px; }
  .service-list, .solution-list { grid-template-columns: 1fr; gap: 24px; }
  .service-item { position: relative; padding: 0 0 24px 48px; border-bottom: 1px solid #e8e8ed; }
  .service-item:last-child { padding-bottom: 0; border: 0; }
  .service-icon { position: absolute; top: 2px; left: 0; font-size: 28px; }
  .service-item p { margin-top: 8px !important; }
  .solution-item { padding: 28px 24px; border-radius: 16px; }
  .solution-heading { gap: 12px; }
  .solution-icon { font-size: 24px; }
  .solution-item p { margin-top: 12px !important; }
  .solution-flow { margin-top: 20px; gap: 8px 10px; }
  .solution-flow span { gap: 10px; }
  .about-copy p { font-size: 15px; }
  .about-copy p + p { margin-top: 18px !important; }
}
@media (prefers-reduced-motion: reduce) {
  .hero-actions .ant-btn-primary, .hero-more .anticon { transition: none; }
}
</style>
